import React, {Component, ReactNode} from 'react'
import { Box, DialogContent, Typography } from '@mui/material';
import {FullWidthRowFlexContainer, RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {NotifyDialogTitle} from '../../../../../components/assocDirector/AssocDirectorCommon'
import {DialogCloseButton} from '../../../../../components/reservations/components/CommonStyle'
import {Check, Close} from '@mui/icons-material'
import {
    ApplyButtonTextWithIcon,
    ApplyDialogActions,
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    SpApplyDialogTitle,
    SpApplyDialogTitleFont,
    StyledHeader,
    StyledHeadingHr,
    StyledPageFooterArea,
} from './NatAdminApplicationCommon'
import {PageFotterAreaRight} from '../../../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDialog} from '../../../../../components/shared/pageBaseComponents/AdminDialog'
import {AppAdminContext} from '../../../../../app/AppAdminContext'

interface Props {
    open: boolean
    delegateComponent: React.ReactNode
    rejectionButtonDisabled: boolean
    approvalButtonDisabled: boolean
    onApproval: () => void
    onRejection: () => void
    onCancel: () => void
}
export default class NatAdminApplicationApprovalDelegateDialog extends Component<Props> {
    declare context: React.ContextType<typeof AppAdminContext>
    constructor(props: Readonly<Props>) {
        super(props)
    }

    renderPc(): ReactNode {
        const {
            delegateComponent,
            rejectionButtonDisabled,
            approvalButtonDisabled,
            onApproval,
            onRejection,
            onCancel,
        } = this.props

        return (
            <Box width={'750px'}>
                <NotifyDialogTitle>
                    <StyledHeader>
                        <RowFlexContainer>
                            <Typography variant="h5" display={'inline'}>
                                承認操作の代行
                            </Typography>
                            <DialogCloseButton onClick={onCancel} id={'close'}>
                                <Close/>
                            </DialogCloseButton>
                        </RowFlexContainer>
                    </StyledHeader>
                    <StyledHeadingHr/>
                </NotifyDialogTitle>
                <DialogContent>{delegateComponent}</DialogContent>
                <ApplyDialogActions>
                    <StyledPageFooterArea>
                        <PageFotterAreaRight>
                            <ApplyRejectionOutlinedButton
                                onClick={onRejection}
                                disabled={rejectionButtonDisabled}
                            >
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton
                                onClick={onApproval}
                                disabled={approvalButtonDisabled}
                            >
                                <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </PageFotterAreaRight>
                    </StyledPageFooterArea>
                </ApplyDialogActions>
            </Box>)
    }

    renderSp(): ReactNode {
        const {
            delegateComponent,
            rejectionButtonDisabled,
            approvalButtonDisabled,
            onApproval,
            onRejection,
            onCancel,
        } = this.props

        return (
            <>
                <SpApplyDialogTitle>
                    <RowFlexContainer>
                        <SpApplyDialogTitleFont>承認操作の代行</SpApplyDialogTitleFont>
                        <DialogCloseButton onClick={onCancel}>
                            <Close fontSize={'large'}/>
                        </DialogCloseButton>
                    </RowFlexContainer>
                </SpApplyDialogTitle>
                <DialogContent>{delegateComponent}</DialogContent>
                <ApplyDialogActions>
                    <FullWidthRowFlexContainer>
                        <ApplyRejectionOutlinedButton
                            onClick={onRejection}
                            disabled={rejectionButtonDisabled}
                        >
                            <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                        </ApplyRejectionOutlinedButton>
                        <Box ml={'24px'}/>
                        <ApplyReceptionOutlinedButton
                            onClick={onApproval}
                            disabled={approvalButtonDisabled}
                        >
                            <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                        </ApplyReceptionOutlinedButton>
                    </FullWidthRowFlexContainer>
                </ApplyDialogActions>
            </>
        )
    }

    render(): ReactNode {
        const spMode = this.context.showSpModePage

        return (
            <AdminDialog maxWidth={'md'} open={this.props.open}>
                {spMode ? this.renderSp() : this.renderPc()}
            </AdminDialog>
        )
    }
}

NatAdminApplicationApprovalDelegateDialog.contextType = AppAdminContext
